import { render, staticRenderFns } from "./photoScanView.vue?vue&type=template&id=001b4d98&scoped=true&"
import script from "./photoScanView.vue?vue&type=script&lang=js&"
export * from "./photoScanView.vue?vue&type=script&lang=js&"
import style0 from "./photoScanView.vue?vue&type=style&index=0&id=001b4d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b4d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/liuminming/Documents/zhunduWork/components/photoScanView/photo-scan-view/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('001b4d98')) {
      api.createRecord('001b4d98', component.options)
    } else {
      api.reload('001b4d98', component.options)
    }
    module.hot.accept("./photoScanView.vue?vue&type=template&id=001b4d98&scoped=true&", function () {
      api.rerender('001b4d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoScanView.vue"
export default component.exports